import {fetchLinesList} from '../../../services/lineServices'
import {lineListActions} from '../line'

const getLinesListAction = (payload) => {
  return (dispatch) => {
    dispatch(lineListActions.linesListRequest())
    fetchLinesList(payload).then((res) => {
      dispatch(lineListActions.linesListSuccess(res))
    }).catch((error) => {
      dispatch(lineListActions.linesListFailure(error))
    })

  }
}

export default getLinesListAction
